import React from "react";
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Collapse from '@mui/material/Collapse';

const DemoAlert = () => {
    const [open, setOpen] = React.useState(true);
    return (
        <Collapse in={open}>
            <Alert
                severity="warning"
                action={
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={() => {
                            setOpen(false);
                        }}
                    >
                        <CloseIcon fontSize="inherit" />
                    </IconButton>
                }
                sx={{ mb: 2 }}
            >
                現在開発中のため、本機能はモックとなります。
            </Alert>
        </Collapse>
    );
};

export default DemoAlert;